import { routes } from '@routes';
import type { FC } from 'react';
import { Navigate } from 'react-router-dom';

export const MeiaStudyCreatePage: FC = () => {
  return (
    <Navigate
      replace
      to={`${routes.meiaStudies.path}?newStudy=true`}
    />
  );
};
